import { useIsDarkTheme } from "@/components/layout/useIsDarkTheme";
import { useMediaQuery } from "react-responsive";

export const LockedTooltip = ({ content, tooltipId, activeTooltip, width, positionConfig }) => {
    const isDarkTheme = useIsDarkTheme();
    const isLargeScreen = useMediaQuery({ minWidth: 1400 });
    const isActive = activeTooltip === tooltipId;
    const hasActiveTooltip = activeTooltip !== null;

    const getBgColor = () => {
        if (isDarkTheme) {
            if (!hasActiveTooltip) return "bg-[#286650]";
            return isActive ? "bg-[#286650]" : "bg-[#1B2C29]";
        }
        if (!hasActiveTooltip) return "bg-[#8FE6BC]";
        return isActive ? "bg-[#8FE6BC]" : "bg-[#DEF7EB]";
    };

    const textColor = isDarkTheme ? "text-[#D3EDE3]" : "text-cm-p-on-surface";

    const getPosition = () => {
        const getResponsivePosition = (config) => {
            if (!config) return {};
            if (isLargeScreen && config.desktop) return config.desktop;
            if (config.mediumScreen) return config.mediumScreen;
            return config;
        };

        if (isActive && positionConfig?.active) {
            return getResponsivePosition(positionConfig.active);
        }
        if (activeTooltip && positionConfig?.[activeTooltip]) {
            return getResponsivePosition(positionConfig[activeTooltip]);
        }
        return getResponsivePosition(positionConfig?.default || {});
    };

    return (
        <div
            className={`hidden lg:block absolute z-[10] rounded-lg px-3 py-2 lg:px-3 lg:py-2 min-[1400px]:px-5 min-[1400px]:py-4 shadow-lg transition-all duration-700 pointer-events-none ${getBgColor()}`}
            style={{ width: width || "auto", ...getPosition() }}
        >
            <p className={`text-sm lg:text-sm min-[1400px]:text-base ${textColor} text-center`}>{content}</p>
        </div>
    );
};
